/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * UserPushNotificationConfigBase
 * auto generated base class for the model UserPushNotificationConfigModel.
 */
export const UserPushNotificationConfigModelBase = ModelBase.named('UserPushNotificationConfig')
  .props({
    __typename: types.optional(types.literal('UserPushNotificationConfig'), 'UserPushNotificationConfig'),
    dailyPokerish: types.union(types.undefined, types.null, types.boolean),
    gamePlay: types.union(types.undefined, types.null, types.boolean)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class UserPushNotificationConfigModelSelector extends QueryBuilder {
  get dailyPokerish() {
    return this.__attr('dailyPokerish')
  }
  get gamePlay() {
    return this.__attr('gamePlay')
  }
}
export function selectFromUserPushNotificationConfig() {
  return new UserPushNotificationConfigModelSelector()
}

export const userPushNotificationConfigModelPrimitives = selectFromUserPushNotificationConfig().dailyPokerish.gamePlay
